import { v4 as uuidv4 } from "uuid";
import config from "../../components/helpers/socket/config";
import { send } from "../sockets/asyncSocket";
import { UserPreferences } from "../../components/contexts/UserPreferencesContext";

export function saveUserPreferences({
  theme,
  app_tour,
  tab_order,
  flashonchatmessage,
  enablepushnotifications,
  enablepushnotificationssound,
  defaultaccount,
  fontSize,
  tradinggridgroupsorder,
  aggregatedview,
  pnlview,
}: UserPreferences) {
  let payload = {
    theme: theme.replace(/\\/g, "").replace(/(^")|("$)/g, ""),
    app_tour: JSON.parse(app_tour || "{}"),
    tab_order: tab_order.replace(/\\/g, "").replace(/(^")|("$)/g, ""),
    flashonchatmessage: flashonchatmessage,
    enablepushnotifications: enablepushnotifications,
    enablepushnotificationssound: enablepushnotificationssound,
    defaultaccount:
      defaultaccount?.replace(/\\/g, "")?.replace(/(^")|("$)/g, "") ?? "",
    fontSize: fontSize
      ? fontSize.replace(/\\/g, "").replace(/(^")|("$)/g, "")
      : "MEDIUM",
    tradinggridgroupsorder: tradinggridgroupsorder
      ?.replace(/\\/g, "")
      ?.replace(/(^")|("$)/g, ""),
    aggregatedview: aggregatedview,
    pnlview: pnlview,
  };
  console.log("saving pref", payload);
  send(config.socket.channels.CORE, {
    action: "savePreference",
    requestID: uuidv4(),
    type: "preference",
    payload: payload,
  });
}
